import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import { FaYoutube } from "react-icons/fa";
import { BsFacebook, BsLinkedin } from "react-icons/bs";
import { FiGithub } from "react-icons/fi";

const Footer = () => {
  return (
    <footer className="text-gray-400 bg-gray-900 body-font">
      <div className="container px-5 py-8 mx-auto flex items-center sm:flex-row flex-col">
        <Link
          to="/"
          className="flex title-font font-medium items-center md:justify-start justify-center text-white"
        >
          <img src={logo} alt="" width={40} />
          <span className="ml-3 text-xl">Study With Anis</span>
        </Link>
        <p className="text-sm text-gray-400 sm:ml-4 sm:pl-4 sm:border-l-2 sm:border-gray-800 sm:py-2 sm:mt-0 mt-4">
          ©{" "}
          <a
            href="https://www.youtube.com/@maruf_sarker"
            target="_blank"
            rel="noreferrer"
            className="text-green-400"
          >
            Md. Maruf Sarker
          </a>{" "}
          | {new Date().getFullYear()} | All Rights Reserved
        </p>
        <span className="inline-flex sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start">
          <a
            href="https://www.youtube.com/c/anisulislamrubel"
            className="text-gray-400 text-xl p-2"
          >
            <FaYoutube />
          </a>
          <a
            href="https://www.facebook.com/studywithanis/"
            className="text-gray-400 text-xl p-2"
          >
            <BsFacebook />
          </a>
          <a
            href="https://github.com/anisul-Islam"
            className="text-gray-400 text-xl p-2"
          >
            <FiGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/anisul2020/"
            className="text-gray-400 text-xl p-2"
          >
            <BsLinkedin />
          </a>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
